export default {
  toasts: {
    success: 'Tarjeta regalo canjeada con éxito.',
    error: 'Error al canjear la tarjeta regalo.',
  },
  title: 'Canjear tarjeta regalo',
  subtitle: 'Introduce el código de la tarjeta regalo y el importe a descontar de la cuenta del cliente.',
  form: {
    amount: {
      label: 'Importe a canjear',
    },
    code: {
      label: 'Código de tarjeta regalo',
    },
  },
  buttons: {
    redeem: 'Canjear',
    cancel: 'Cancelar',
  },
};
